import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import styled from '@mui/material/styles/styled';

const LoaderBackground = styled('div')(() => ({
  background: 'rgba(0,0,0,0.37)',
  position: 'fixed',
  zIndex: 9999,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  height: '100vh',
  left: 0,
  top: 0,
  bottom: 0,
  right: 0,
}));

interface FullLoaderProps {
  size?: number;
}
/**
 * @deprecated use CircularProgress from atoms/CircularProgress instead
 */
const FullLoader: React.FC<FullLoaderProps> = ({ size = 80 }) => (
  <LoaderBackground>
    <CircularProgress size={size} />
  </LoaderBackground>
);

export default FullLoader;
